import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[psCountryViewableCellContent]',
})
export class CountryViewableCellContentDirective {
  constructor(public template: TemplateRef<unknown>) {}
}
